import { REACT_APP_BUCKET_NAME } from 'src/environments/environment';

export const getS3URL = () => `https://${REACT_APP_BUCKET_NAME}.s3.us-east-2.amazonaws.com/`;
